export enum TransactionTypeEnum {
  Requisition = 'check_requisition',
  Receipt = 'receipt',
  Expense = 'expense',
  Deposit = 'deposit',
  Invoice = 'invoice',
  BudgetTransfer = 'budget_transfer',
  AccountTransfer = 'account_transfer',
  Transaction = 'transaction',
  Transfer = 'transfer',
  Complete = 'complete',
  AchTransfer = 'ach_transfer',
  Order = 'order',
  SplitDeposit = 'split-deposit',
  SplitExpense = 'split-expense'
}

export enum BalanceTypeEnum {
  AccountDebit = 'account_debit',
  AccountCredit = 'account_credit',
  BudgetDebit = 'budget_debit',
  BudgetCredit = 'budget_credit',
}

export enum AccountTypeEnum {}
